import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';

import { EventTypes } from '../types';
import { EventAdapter } from './EventAdapter';

export type CreatePortalSessionEventData = {
  source:
    | 'account_page__manage'
    | 'account_page__renew'
    | 'account_page_teams__manage'
    | 'account_page_teams__renew'
    | 'account_page_teams__upgrade'
    | 'account_page_teams__seats_available_dialog'
    | 'account_page_teams__add_seats_dialog'
    | 'pricing_table__upgrade'
    | 'pricing_table__manage';
  team_id: string;
};
export class CreatePortalSessionEventAdapter extends EventAdapter<CreatePortalSessionEventData> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendEventData(
    event: CreatePortalSessionEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.CreatePortalSession, event);
  };

  constructor({ source, team_id }: CreatePortalSessionEventData) {
    super();
    this.eventData = {
      source,
      team_id,
    };
  }
}
